import EmptyCell from 'components/new-ui/base/emtpy-cell/EmptyCell';
import TooltipWithCopy from 'components/ui/composed/tooltipWithCopy/TooltipWithCopy';

type Props = {
    mrn: string | undefined;
    dataTestId?: string;
};

const Mrn = ({ mrn, dataTestId }: Props) => {
    if (!mrn) {
        return <EmptyCell dataTestId={dataTestId} />;
    }

    return (
        <TooltipWithCopy dataTestId={dataTestId} copyText={mrn}>
            {mrn}
        </TooltipWithCopy>
    );
};

export default Mrn;
